import mixpanel from "mixpanel-browser";

import { getExpoEASConstant } from "@/utils/expoConstants";

import { isAnalyticsTrackingAllowed } from "../../analyticsTrackingConsent";
import { KnownEvent, EventPropertiesMap } from "../../events";
import { validMixpanelEnvs } from "../../types";

/**
 *
 * @param event provide a string identifier for the event. Usually [FLOW] -> specific step
 * @param properties arbitrary key value pairs to add additional data
 */
export const trackEvent = <E extends KnownEvent>(
  event: E,
  properties: EventPropertiesMap[E] & { clubSlug: string }
) => {
  const env = getExpoEASConstant("deployEnv");
  if (isAnalyticsTrackingAllowed() && validMixpanelEnvs.includes(env)) {
    mixpanel.track(event, {
      ...properties,
      "whoosh-app": "patron",
      "whoosh-platform": "web",
    });
  }
};
